<template>
  <NavBar />
  <HamburgerMenu />
  <router-view />
  <ScrollTop />
  <DownloadStartedPanel />
  <FooterBar />
</template>

<script>
import FooterBar from './components/FooterBar.vue';
import HamburgerMenu from './components/HamburgerMenu.vue';
import NavBar from './components/NavBar.vue';
import ScrollTop from './components/ScrollTop.vue';
import DownloadStartedPanel from './components/DownloadStartedPanel.vue';

export default {
  name: 'App',
  components: {
    NavBar,
    HamburgerMenu,
    ScrollTop,
    DownloadStartedPanel,
    FooterBar,
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-image: url('../public/images/bodyBG.jpg');
  background-size: cover;
  overflow-x: hidden;
}
</style>
